/* eslint-disable */
export default {
  removeMeetingWarning:
    'O recurso de agendamento foi descontinuado. Use o {app} para agendar suas reuniões por vídeo.',
  scheduleMeetingTips:
    'Observe que removemos as reuniões deste aplicativo. Para reuniões, recomendamos usar o {app}.',
  migrateToPluginAlert:
    'Observação: este aplicativo não funcionará com o Outlook 2016 e inferior e com o Internet Explorer 11. Atualize o Outlook ou alterne para o Microsoft Edge. Você também pode usar o {app}',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
